// Registry for loaded stores to support synchronous access
// Extracted to avoid TDZ issues in circular dependencies

export const preloadedStores = {}

export function getLoadedStore(storeName) {
  const hook = preloadedStores[storeName]
  if (!hook) return null
  try {
    // hook may be a function that returns the store, or it may already be a store instance
    if (typeof hook === 'function') return hook()
    if (hook && typeof hook === 'object') return hook
    return null
  } catch {
    return null
  }
}
